export default __webpack_public_path__ + "static/media/networkDown.144c66b4.svg";